// 西班牙语
const esImg = {}
// 葡萄牙语
const ptImg = {}
// 英语
const enImg = {}
// 简中
const cnImg = {}
// 繁中
const tcImg = {};
// 泰语
const thImg = {};
// 印尼语
const idImg = {};

const imgMap = {
  '--navibtn-video': 'video.png',
  '--navibtn-skin': 'skin.png',
  '--navibtn-game': 'game.png',
  '--navibtn-video-a': 'video_a.png',
  '--navibtn-skin-a': 'skin_a.png',
  '--navibtn-game-a': 'game_a.png',
  '--page-logo': 'logo.png',
  '--page-login': 'login.png',
  '--page-logout': 'logout.png',
  '--video-title': 'video_title.png',
  '--game-title': 'game_title.png',
  '--game-btn-goal': 'game_btn_goal.png',
  '--game-float-btn': 'game_float_btn.png',
  '--skin-title-1': 'skin_title_1.png',
  '--skin-title-2': 'skin_title_2.png',
  '--skin-title-3': 'skin_title_3.png',
  '--skin-title-4': 'skin_title_4.png',
  '--skin-title-5': 'skin_title_5.png',
  '--skin-title-6': 'skin_title_6.png',
  '--skin-detail-1': 'skin_detail_1.png',
  '--skin-detail-2': 'skin_detail_2.png',
  '--skin-detail-3': 'skin_detail_3.png',
  '--skin-detail-4': 'skin_detail_4.png',
  '--skin-detail-5': 'skin_detail_5.png',
  '--skin-detail-6': 'skin_detail_6.png',
  '--skin-detail-7': 'skin_detail_7.png',
  '--skin-tip-1': 'skin_tip_1.png',
  '--skin-tip-2': 'skin_tip_2.png',
  '--skin-title': 'skin_title.png', 
  '--plane-title-word': 'plane_title_word.png', 
  '--home-title': 'home_title.png',
  '--home-book-gift': 'book_gift.png',
  '--home-regist-btn': 'home_regist_btn.png',
  '--home-gift-title': 'home_gift_title.png',
  '--login-confirm': 'login_confirm.png',
  '--login-verify': 'login_verify.png',
  '--login-send': 'login_send.png',
  '--reward-title': 'reward_title.png',
  '--modal-login': 'modal_login.png', 
  '--modal-event': 'modal_event.png', 
  '--modal-reward': 'modal_reward.png', 
  '--modal-rule': 'modal_rule.png' 
}
Object.keys(imgMap).forEach((key) => {
  cnImg[key] = `url('${
    new URL(`./cn/${imgMap[key]}`, import.meta.url).href
  }')`;
  enImg[key] = `url('${
    new URL(`./en/${imgMap[key]}`, import.meta.url).href
  }')`;
  esImg[key] = `url('${
    new URL(`./es/${imgMap[key]}`, import.meta.url).href
  }')`;
  ptImg[key] = `url('${
    new URL(`./pt/${imgMap[key]}`, import.meta.url).href
  }')`;
  idImg[key] = `url('${
    new URL(`./id/${imgMap[key]}`, import.meta.url).href
  }')`;
  thImg[key] = `url('${
    new URL(`./th/${imgMap[key]}`, import.meta.url).href
  }')`;
  tcImg[key] = `url('${
    new URL(`./tc/${imgMap[key]}`, import.meta.url).href
  }')`;
})

export { enImg, ptImg, esImg, cnImg, idImg, thImg, tcImg }
